<div *ngIf="this.loader.getLoading()" class="cssload-container">
    <!-- <div class="cssload-speeding-wheel"></div> -->
  </div>
  